import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import InputField from 'components/form/InputField';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import logoIcon from 'utils/icon/carpe.png';
import PrimaryButton from 'components/button/PrimaryButton';
import { Link, useParams } from 'react-router-dom';
import { userApi } from 'apis/user/userApi';
import { ToastContainer, toast } from 'react-toastify';

const VerifyEmail: React.FC = () => {
  const { email } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const [isVerify, setIsVerify] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit: SubmitHandler<any> = async (data) => {
    setLoading(true);
    const response = await userApi.verify(email, data.code);
    if (response.isSuccess) {
      setIsVerify(true);
    } else {
      toast(response.error);
    }
    setLoading(false);
  };

  return (
    <>
      <PageWrapper>
        <LoginWrapper>
          <LogoWrapper>
            <img src={logoIcon} alt='logo' className='logo' />
          </LogoWrapper>
          <FormWrapper>
            <TitleWrapper>
              {isVerify ? (
                <p>케빈 서비스에 오신것을 환영합니다.</p>
              ) : (
                <>
                  <p>
                    베타버전에서 이메일 인증은 도입되지 않았습니다. 아무 값을
                    입력하고 진행해주세요
                  </p>
                  <p className='email'>{email}</p>
                </>
              )}
            </TitleWrapper>
            {isVerify ? (
              <InputWrapper>
                <TitleWrapper>
                  <p>
                    가입이 완료되었습니다. <br /> 추가 권한이 필요한 경우
                    관리자에게 문의하세요
                  </p>
                </TitleWrapper>
                <div>
                  <Link to='/login'>
                    <PrimaryButton
                      text='Login'
                      height='40px'
                      width='100%'
                      bgColor={theme.colors.blue_500}
                      textColor='#ffffff'
                      fontWeight={theme.fontWeights.medium}
                      fontSize={theme.fontSizes.normal}
                      border={`1px solid ${theme.colors.blue_500}`}
                      rounded='6px'
                      hoverBgColor={theme.colors.blue_600}
                      activeBgColor={theme.colors.blue_800}
                      selectedBgColor={theme.colors.blue_700}
                      loading={loading}
                    />
                  </Link>
                </div>
              </InputWrapper>
            ) : (
              <form
                onSubmit={handleSubmit(onSubmit)}
                className='space-y-[12px]'
              >
                <InputWrapper>
                  <InputField
                    register={register}
                    errors={errors}
                    title={`Verification code`}
                    name='code'
                    type='string'
                    placeHolder='베타버전입니다. 아무 값이나 입력해주세요'
                    errText='This field is required'
                    opts={{
                      required: 'This field is required',
                      maxLength: {
                        value: 100,
                        message: 'Email address is too long',
                      },
                      minLength: {
                        value: 1,
                        message: 'Email address is too short',
                      },
                    }}
                  />
                </InputWrapper>
                <FooterFormWrapper>
                  <button className='submit-btn'>
                    <PrimaryButton
                      text='Next'
                      height='40px'
                      width='100%'
                      bgColor={theme.colors.blue_500}
                      textColor='#ffffff'
                      fontWeight={theme.fontWeights.medium}
                      fontSize={theme.fontSizes.normal}
                      border={`1px solid ${theme.colors.blue_500}`}
                      rounded='6px'
                      hoverBgColor={theme.colors.blue_600}
                      activeBgColor={theme.colors.blue_800}
                      selectedBgColor={theme.colors.blue_700}
                      loading={loading}
                    />
                  </button>
                </FooterFormWrapper>
              </form>
            )}
          </FormWrapper>
        </LoginWrapper>
      </PageWrapper>
      <ToastContainer />
    </>
  );
};

export default VerifyEmail;

const PageWrapper = styled.div`
  background-color: #fbfbfb;
  width: 100%;
  height: 100vh;
  a {
    text-decoration: none;
  }
`;

const LoginWrapper = styled.div`
  margin: 0 auto;
  width: 80%;
  @media (min-width: 1440px) {
    width: 40%;
  }
`;

const FormWrapper = styled.div`
  background: #ffffff;
  border: 1px solid ${theme.colors.gray_8};
  border-radius: 32px;
  padding: 48px;
`;

const TitleWrapper = styled.div`
  margin-bottom: 16px;
  text-align: center;
  line-height: 24px;
  letter-spacing: 0.1px;
  p {
    font-size: ${theme.fontSizes.normal};
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.medium};
  }
  .email {
    font-weight: ${theme.fontWeights.bold};
  }
`;

const InputWrapper = styled.div`
  width: 60%;
  margin: 0 auto;
  & > * + * {
    margin-top: 24px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  margin-bottom: 26px;
  .logo {
    width: 157px;
    height: 102px;
  }
`;

const FooterFormWrapper = styled.div`
  width: 60%;
  margin: 0 auto;
  margin-top: 32px;
  & > * + * {
    margin-top: 12px;
  }
  .submit-btn {
    width: 100%;
  }
  .forget-text {
    font-size: ${theme.fontSizes.normal};
    font-weight: ${theme.fontWeights.medium};
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
    text-align: center;
    cursor: pointer;
  }
`;
